<template>
  <v-navigation-drawer 
    v-model="drawer" 
    :width="90"
    location="end"
    permanent 
    right 
    class="elegant-sidebar"
  >
    <!-- Menu Principal -->
    <div class="menu-container">
      <div
        v-if="isAutoLogin"
        class="menu-item"
      >
        <v-tooltip location="left">
          <template #activator="{ props }">
            <v-btn
              v-bind="props"
              icon
              variant="outlined"
              size="large"
              class="menu-btn"
              color="grey-darken-2"
              @click="toggleTheme"
            >
              <v-icon size="large">
                {{ isDark ? 'dark_mode' : 'light_mode' }}
              </v-icon>
            </v-btn>
          </template>
          <span>Alterar tema</span>
        </v-tooltip>
      </div>

      <div 
        v-for="(item, i) in displayItems"
        :key="i" 
        class="menu-item"
      >
        <v-tooltip location="left">
          <template #activator="{ props }">
            <v-btn 
              v-bind="props"
              :disabled="item.disabled" 
              :color="selectedItem === i ? 'primary' : 'grey-darken-2'"
              icon 
              variant="outlined" 
              size="large"
              class="menu-btn"
              :class="{
                'menu-btn-active': selectedItem === i,
                'menu-btn-disabled': item.disabled
              }"
              @click="handleClick(i, item)"
            >
              <v-icon size="large">
                {{ item.icon }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ item.label }}</span>
        </v-tooltip>
      </div>
    </div>

    <!-- Footer Menu Container (Configuração e Logout) -->
    <div class="footer-menu-container">
      <div 
        v-for="(item, i) in footerItems"
        :key="`footer-${i}`" 
        class="menu-item"
      >
        <v-tooltip location="left">
          <template #activator="{ props }">
            <v-btn 
              v-bind="props"
              :disabled="item.disabled" 
              :color="selectedItem === (items.length + i) ? 'primary' : 'grey-darken-2'"
              icon 
              variant="outlined" 
              size="large"
              class="menu-btn"
              :class="{
                'menu-btn-active': selectedItem === (items.length + i),
                'menu-btn-disabled': item.disabled
              }"
              @click="handleClick(items.length + i, item)"
            >
              <v-icon size="large">
                {{ item.icon }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ item.label }}</span>
        </v-tooltip>
      </div>

      <!-- Logout -->
      <v-tooltip
        v-if="!isAutoLogin"
        location="left"
      >
        <template #activator="{ props }">
          <v-btn 
            v-bind="props"
            color="red" 
            variant="outlined" 
            size="large"
            class="logout-btn"
            @click="logout()"
          >
            <v-icon size="large">
              logout
            </v-icon>
          </v-btn>
        </template>
        <span>Sair</span>
      </v-tooltip>
    </div>
  </v-navigation-drawer>
</template>

<script>
import EventBus from '@/EventBus'
import medicoService from '../../services/medico.service'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    isAutoLogin: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    selectedItem: 0, // Index do item selecionado - ATENDIMENTO como padrão
    drawer: true,
    user: null,
    rail: true,
    show: true,
    qtdLaudos: 0,
    load: false,
    items: [
      { icon: 'home', color: 'primary', label: 'Tela Inicial', disabled: false, item: "TELA_INICIAL" },
      { icon: 'medical_services', color: 'primary', label: 'Atendimento', disabled: false, item: "ATENDIMENTO"},
      { icon: 'assignment', color: 'primary', label: 'Laudos Técnicos', disabled: true, item: "LAUDOS_TECNICOS" },
      { icon: 'history_edu', color: 'primary', label: 'Prontuários de Retorno', disabled: true, item: "PRONTUARIOS_RETORNO" }
    ],
    footerItems: [
      { icon: 'settings', color: 'primary', label: 'Configuração', disabled: false, item: "CONFIGURACAO" }
    ]
  }),
  computed: {
    ...mapGetters('theme', ['isDark']),
    displayItems () {
      if (this.isAutoLogin) {
        return this.items.filter(item => item.item !== 'TELA_INICIAL')
      }
      return this.items
    }
  },
  mounted () {
    EventBus.on('showSideBar', (data) => {
      this.show = data
    })
    EventBus.on('reloadQuantidadeLaudosTec', () => {
      this.quantidadeLaudosTec()
    })
    this.user = this.$store.getters.usuario
    this.quantidadeLaudosTec()
  },
  beforeUnmount() {
    EventBus.off('showSideBar')
  },
  methods: {
    ...mapActions('theme', ['toggleTheme']),
    logout () {
      this.$store.dispatch('setPaciente', null)
      this.$store
        .dispatch('FedLogOut')
        .then(() => {
          this.$router.push('/')
        }).catch(() => {
        })
    },
    handleClick (index, item) {
      if (!item.disabled) {
        this.selectedItem = index // Atualiza o índice do item selecionado
        this.$emit('selecionado', item.item)
      }
    },
    quantidadeLaudosTec () {
      this.load = false
      medicoService.medico.quantidadeLaudosTec(this.user.idPrestador).then(r => {
        if (r.status === 200) {
          this.items[2].messages = r.data.msg
        }
      }).finally(() => {
        this.load = false
      })
    }
  }
}
</script>

<style scoped>
.elegant-sidebar {
  background: linear-gradient(180deg, rgba(var(--v-theme-primary), 0.02) 0%, rgba(var(--v-theme-secondary), 0.01) 100%);
  border-left: 1px solid rgba(var(--v-theme-primary), 0.1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 0;
  backdrop-filter: blur(10px);
  width: 90px !important; /* Tamanho fixo */
}

.menu-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  flex: 1;
  /* Ocupa o espaço restante */
}

.menu-item {
  display: flex;
  justify-content: center;
}

.menu-btn {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  border: 2px solid rgba(var(--v-theme-primary), 0.1);
  background: rgba(255, 255, 255, 0.8);
}

.menu-btn:hover {
  background: rgba(var(--v-theme-primary), 0.05);
  transform: translateY(-2px);
  border-color: rgba(var(--v-theme-primary), 0.3);
  box-shadow: 0 8px 25px rgba(var(--v-theme-primary), 0.15);
}

.menu-btn-active {
  background: rgba(var(--v-theme-primary), 0.1) !important;
  color: rgb(var(--v-theme-primary)) !important;
  border-color: rgba(var(--v-theme-primary), 0.4) !important;
  box-shadow: 
    0 8px 25px rgba(var(--v-theme-primary), 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.2) !important;
  transform: translateY(-2px);
}

.menu-btn-active::before {
  content: '';
  position: absolute;
  left: -12px;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 24px;
  background: linear-gradient(180deg, rgb(var(--v-theme-primary)), rgb(var(--v-theme-secondary)));
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.4);
}

.menu-btn-disabled {
  opacity: 0.3;
  cursor: not-allowed;
  pointer-events: none;
  border-color: rgba(0, 0, 0, 0.1) !important;
}

.menu-btn-disabled:hover {
  background: transparent !important;
  transform: none !important;
  box-shadow: none !important;
}

.logout-container {
  display: flex;
  justify-content: center;
  padding-top: 20px;
  border-top: 1px solid rgba(var(--v-theme-primary), 0.1);
}

.footer-menu-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  padding-top: 20px;
  border-top: 1px solid rgba(var(--v-theme-primary), 0.1);
  margin: 0 16px; /* Para manter o espaçamento lateral */
}

.logout-btn {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  transition: all 0.3s ease;
  border: 2px solid rgba(var(--v-theme-error), 0.1);
  background: rgba(255, 255, 255, 0.8);
}

.logout-btn:hover {
  background: rgba(var(--v-theme-error), 0.05);
  transform: translateY(-2px);
  border-color: rgba(var(--v-theme-error), 0.3);
  box-shadow: 0 8px 25px rgba(var(--v-theme-error), 0.15);
}

/* Efeito de brilho suave nos botões ativos */
.menu-btn-active::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 14px;
  background: radial-gradient(circle at center, rgba(var(--v-theme-primary), 0.1) 0%, transparent 70%);
  animation: gentleGlow 2s ease-in-out infinite alternate;
}

@keyframes gentleGlow {
  from {
    opacity: 0.3;
  }
  to {
    opacity: 0.6;
  }
}

/* Efeito de ripple suave */
.menu-btn::after,
.logout-btn::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: inherit;
  background: currentColor;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.menu-btn:hover::after,
.logout-btn:hover::after {
  opacity: 0.05;
}

/* Ícones com transição suave */
.menu-btn :deep(.v-icon),
.logout-btn :deep(.v-icon) {
  transition: all 0.3s ease;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.menu-btn:hover :deep(.v-icon),
.logout-btn:hover :deep(.v-icon) {
  transform: scale(1.1);
}

.menu-btn-active :deep(.v-icon) {
  transform: scale(1.1);
  filter: drop-shadow(0 4px 8px rgba(var(--v-theme-primary), 0.3));
}

/* Responsividade */
@media (max-width: 768px) {
  .elegant-sidebar {
    padding: 16px 0;
    width: 80px !important;
  }
  
  .menu-btn,
  .logout-btn {
    width: 52px;
    height: 52px;
  }
  
  .menu-container {
    gap: 10px;
  }
  
  .menu-btn-active::before {
    left: -10px;
    width: 3px;
    height: 20px;
  }
}

/* Animações de entrada */
.menu-item {
  animation: slideInRight 0.5s ease-out both;
}

.menu-item:nth-child(1) { animation-delay: 0.1s; }
.menu-item:nth-child(2) { animation-delay: 0.2s; }
.menu-item:nth-child(3) { animation-delay: 0.3s; }
.menu-item:nth-child(4) { animation-delay: 0.4s; }
.menu-item:nth-child(5) { animation-delay: 0.5s; }
.menu-item:nth-child(6) { animation-delay: 0.6s; }

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Scrollbar personalizada (caso precise em telas muito pequenas) */
.elegant-sidebar::-webkit-scrollbar {
  width: 4px;
}

.elegant-sidebar::-webkit-scrollbar-track {
  background: rgba(var(--v-theme-primary), 0.05);
  border-radius: 2px;
}

.elegant-sidebar::-webkit-scrollbar-thumb {
  background: rgba(var(--v-theme-primary), 0.2);
  border-radius: 2px;
}

.elegant-sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-theme-primary), 0.3);
}
</style>
